import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/employees"; // Matches your backend route

// Fetch Employees
export const fetchEmployees = createAsyncThunk("employees/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  return response.data;
});

// Add Employee
export const addEmployee = createAsyncThunk("employees/add", async (employeeData) => {
  const response = await hrmsPostRequest(API_URL, employeeData, true); // Set isMultipart to true for file uploads
  return response.data;
});

// Update Employee
export const updateEmployee = createAsyncThunk("employees/update", async ({ id, updatedData }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData, true);
  return response.data;
});

// Delete Employee
export const deleteEmployee = createAsyncThunk("employees/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

const employeeSlice = createSlice({
  name: "employees",
  initialState: {
    employees: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployees.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.employees = action.payload;
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addEmployee.fulfilled, (state, action) => {
        state.employees.push(action.payload);
      })
      .addCase(updateEmployee.fulfilled, (state, action) => {
        const index = state.employees.findIndex((emp) => emp.id === action.payload.id);
        if (index !== -1) {
          state.employees[index] = action.payload;
        }
      })
      .addCase(deleteEmployee.fulfilled, (state, action) => {
        state.employees = state.employees.filter((emp) => emp.id !== action.payload);
      });
  },
});

export default employeeSlice.reducer;